import { render } from "./Waline.vue?vue&type=template&id=b2e19ddc"
import script from "./Waline.vue?vue&type=script&lang=ts"
export * from "./Waline.vue?vue&type=script&lang=ts"
script.render = render

export default script